import React, { createContext, useContext } from 'react';
import type { ATContextProviderProps } from './types';

export type ATPageSizeCtxType = {
  pageSize: number;
  setPageSize: React.Dispatch<React.SetStateAction<number>>;
};

const ATPageSizeContext = createContext<ATPageSizeCtxType>({
  pageSize: 50,
  setPageSize: () => null,
});

export const useATPageSize = (): ATPageSizeCtxType => {
  const ctx = useContext(ATPageSizeContext);
  if (ctx === null) {
    throw new Error('useATPageSize must be used within a ATPageSizeProvider');
  }
  return ctx;
};

export const ATPageSizeContextProvider: React.FC<ATContextProviderProps> = ({
  children,
}) => {
  const [pageSize, setPageSize] = React.useState<number>(50);

  const pageSizeValue = React.useMemo(
    () => ({
      pageSize,
      setPageSize,
    }),
    [pageSize],
  );

  return (
    <ATPageSizeContext.Provider value={pageSizeValue}>
      {children}
    </ATPageSizeContext.Provider>
  );
};
